import { html, LitElement } from 'lit'
import NavNode from './nav-node.js'

import styleUrl from '../../css/styles.css?url'

export default class HedeliusBaseItem extends LitElement {
    static properties = {
        node: { type: NavNode },
    }

    constructor() {
        super()
        this.node = null
    }

    _handleClick(e, item) {
        if (item.children && item.children.length > 0) {
            e.preventDefault()
        }

        const customEvent = new CustomEvent('hedelius-column-click', {
            bubbles: true,
            composed: true,
            detail: { item },
        })
        this.dispatchEvent(customEvent)
    }

    // Template method for customizing the anchor. Can be overridden in subclasses.
    renderAnchor() {
        return html`
            <li class="py-8 pr-5">
                <a @click="${(e) => this._handleClick(e, this.node)}" href="${this.node.href}">
                    ${this.node.title}
                </a>
            </li>
        `
    }

    render() {
        return html`
            <link rel="stylesheet" href="${styleUrl}" />
            ${this.renderAnchor()}
        `
    }
}
